<div [cfaLoading]="isLoading">
  <app-breadcrumbs></app-breadcrumbs>
  <div class="store-number-toolbar">
    <button mat-raised-button (click)="getRestaurantNetwork()" color="primary" id="store-number-search-button">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput (keydown.enter)="getRestaurantNetwork()"
        [(ngModel)]="storeNumber" />
    </mat-form-field>
  </div>
  <div class="subsection-card-container">
    @if (network != null) {
      <div class="nav-cards-container">
        <app-meraki-network-card [network]="network"></app-meraki-network-card>
        <div id="add-tags-mat-card">
          <mat-card>
            <mat-card-header>
              <mat-card-title>Add Tags</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <mat-form-field id="network-tags-input-field" appearance="outline">
                <mat-label>Tags</mat-label>
                <input matInput (keydown.enter)="updateNetworkTags()" [(ngModel)]="networkTags" />
                <mat-hint>Tags are space separated</mat-hint>
              </mat-form-field>
              <button mat-raised-button (click)="updateNetworkTags()" color="primary" id="add-tags-input-button" class="icon-only-button">
                <mat-icon>done</mat-icon>
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    }
  </div>
</div>